export class ChangeEvent extends Event {
  constructor(input, parentEvent = null) {
    super('dspFilter.change');
    this.input = input;
    this.parentEvent = parentEvent;
  }
}
